/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content, no-script-url */
/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import _, { mapObject, constant } from 'underscore';
import {
  Dropdown,
  MenuItem,
} from '@bingads-webui-react/primitive-unthemed';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import { DefaultButton, Label, Stack } from '@bingads-webui-react/fabric-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { UploadProgress } from '@bingads-webui-campaign-react/upload-file-picker';
import {
  EncodingPlaceholderWithStyle,
  UnverifiedPlaceholderWithStyle,
  FailedPlaceholderWithStyle
} from '@bingads-webui-campaign-react/video-status-placeholder';

import { ImageExperienceVideo } from '../model/image-experience-video';
import C from '../constants';
import { PreviewThumbnail } from '../edit-video/thumbnail/preview-thumbnail';
import { getVideoListViewStyle } from '../../style/js/video-list-view-style';
import { CustomThumbnailRecordType } from '../types';

export class VideoListViewInternal extends React.PureComponent {
  onEditSelect = (eventKey, event) => {
    const { type } = event.target.parentNode.parentNode.dataset;

    switch (eventKey) {
      case 'replace':
        this.props.onReplace(type);
        break;
      case 'edit':
        this.props.onEdit(type);
        break;

      default:
        break;
    }
  };

  render() {
    const {
      i18n,
      onCancelUpload,
      uploadVideo,
      permissions: { IsVideoAdEditorEnabled },
      customThumbnailRecord,
      allowedVideoSizes,
      onRenderItemDropdown,
      disableRemoveAll,
      hideRatioLabel,
    } = this.props;

    const videoTypes = allowedVideoSizes || C.videoTypesWithOrder;

    return (
      <div className={`image-list-view-content ${this.props.classes.root}`}>
        <div className="image-list clearfix">
          <div>
            <Label>
              <Stack horizontal verticalAlign="center" >
                {this.props.i18n.getString('ImageExperience_Video_Label')}
                <HelpPopupInline
                  topic="pop_BA_VideoAds_VideoSource"
                  ariaLabel={this.props.i18n.getString('Click to learn more about {{item}}', { item: this.props.i18n.getString('ImageExperience_Video_List_Label') })}
                  aria-label={this.props.i18n.getString('Click to learn more about {{item}}', { item: this.props.i18n.getString('ImageExperience_Video_List_Label') })}
                />
              </Stack>
            </Label>
          </div>
          <div className="image-list-content">
            {
              videoTypes.map((type) => {
                const video = _.find(this.props.videoList, _video => _video.Type === type);
                let isUpload = false;

                let component = null;
                if (!video) {
                  component = null;
                } else if (uploadVideo && uploadVideo.type === video.Type) {
                  isUpload = true;
                  component = (
                    <div
                      className="image-list-item-status-indicator"
                      style={{
                        width: Math.max(150, 150 * C.videoAspectRatios[video.Type].ratio),
                        height: 150,
                        paddingTop: 40,
                      }}
                    >
                      <UploadProgress
                        totalBytes={uploadVideo.file.size}
                        uploadedBytes={uploadVideo.uploadedBytes}
                        i18n={i18n}
                        type="circle"
                      />
                      <div className="cancel-upload-button-container">
                        <DefaultButton
                          className="cancel-upload-button"
                          ariaLabel={`${i18n.getString('Audience_Campaign_Cancel_Label')} ${i18n.getString('ImageExperience_Upload')}`}
                          text={i18n.getString('Audience_Campaign_Cancel_Label')}
                          onClick={onCancelUpload}
                        />
                      </div>
                    </div>
                  );
                } else if (video.status === 'Active') {
                  const thumbnail = customThumbnailRecord[C.videoTypeToThumbnailType[video.Type]];
                  const thumbnailSrc =
                    (thumbnail && thumbnail.ThumbnailUrl) || video.ThumbnailUrl;
                  component = (
                    <PreviewThumbnail
                      ratio={C.videoAspectRatios[video.Type].ratio}
                      thumbnail={thumbnailSrc}
                      containerHeight={150}
                      thumbnailMode={thumbnail ? 'Manual' : 'Automatic'}
                    />
                  );
                } else if (video.status === 'Draft' || video.status === 'Transcoding') {
                  component = (
                    <div
                      className="image-list-item-status-indicator"
                      style={{
                        width: Math.max(150, 150 * C.videoAspectRatios[video.Type].ratio),
                        height: 150,
                      }}
                    >
                      <EncodingPlaceholderWithStyle placeholderContent={i18n.getString('ImageExperience_Video_Status_Encoding')} textColor="white" />
                    </div>
                  );
                } else if (video.status === 'Unverified') {
                  component = (
                    <div
                      className="image-list-item-status-indicator"
                      style={{
                        width: Math.max(150, 150 * C.videoAspectRatios[video.Type].ratio),
                        height: 150,
                      }}
                    >
                      <UnverifiedPlaceholderWithStyle placeholderContent={i18n.getString('ImageExperience_Video_Status_Unverified')} textColor="white" />
                    </div>
                  );
                } else if (video.status === 'Failed') {
                  component = (
                    <div
                      className="image-list-item-status-indicator"
                      style={{
                        width: Math.max(150, 150 * C.videoAspectRatios[video.Type].ratio),
                        height: 150,
                      }}
                    >
                      <FailedPlaceholderWithStyle placeholderContent={i18n.getString('ImageExperience_Video_Status_Failed')} textColor="white" />
                    </div>
                  );
                }

                const dropdownComponent = onRenderItemDropdown ? onRenderItemDropdown(this.props, video) : (
                  <Dropdown
                    className="image-edit-dropdown"
                    onSelect={this.onEditSelect}
                    id="image-edit-dropdown"
                  >
                    <Dropdown.Toggle aria-label={this.props.i18n.getString('ImageExperience_Edit_Video_Label', {
                      // eslint-disable-next-line max-len
                      ratio: C.videoAspectRatios[type].text,
                    })}
                    />
                    <Dropdown.Menu data-type={type}>
                      <MenuItem eventKey="replace" disabled={isUpload}>
                        {this.props.i18n.getString('ImageExperience_Replace')}
                      </MenuItem>
                      {
                        IsVideoAdEditorEnabled &&
                        <MenuItem eventKey="edit" disabled={isUpload}>
                          {this.props.i18n.getString('ImageExperience_EditVideo')}
                        </MenuItem>
                      }
                    </Dropdown.Menu>
                  </Dropdown>);

                return (
                  <div
                    className="image-list-item"
                    key={type}
                  >
                    <div className="image-list-item-video" data-video-id={video && video.IdString}>
                      {component}
                      {dropdownComponent}
                    </div>
                    {!hideRatioLabel && (
                      <div className="image-item-ratio-label">
                        {this.props.i18n.getString(C.videoAspectRatios[type].stringKey)}
                      </div>)
                    }
                  </div>
                );
              })
            }
            {
              !disableRemoveAll && (
                <button
                  className="remove-all-button"
                  onClick={this.props.onRemoveAll}
                  aria-label={this.props.i18n.getString('ImageExperience_RemoveAllVideos')}
                />
              )
            }

          </div>
        </div>
      </div>
    );
  }
}

VideoListViewInternal.propTypes = {
  videoList: PropTypes.arrayOf(PropTypes.instanceOf(ImageExperienceVideo)).isRequired,
  customThumbnailRecord: CustomThumbnailRecordType,
  uploadVideo: PropTypes.shape({
    type: PropTypes.string.isRequired,
    uploadedBytes: PropTypes.number.isRequired,
    file: PropTypes.instanceOf(File).isRequired,
  }),
  onReplace: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemoveAll: PropTypes.func.isRequired,
  onCancelUpload: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape(mapObject(
    getVideoListViewStyle(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  permissions: PropTypes.shape({
    IsVideoAdEditorEnabled: PropTypes.bool,
  }),
  allowedVideoSizes: PropTypes.arrayOf(PropTypes.string),
  onRenderItemDropdown: PropTypes.func,
  disableRemoveAll: PropTypes.bool,
  hideRatioLabel: PropTypes.bool,
};

VideoListViewInternal.defaultProps = {
  uploadVideo: null,
  permissions: {},
  customThumbnailRecord: {},
  allowedVideoSizes: null,
  onRenderItemDropdown: null,
  disableRemoveAll: false,
  hideRatioLabel: false,
};

export const VideoListView = withDefaultStyles(VideoListViewInternal, getVideoListViewStyle);
